import { useMemo } from "react";
import { getTeamDisplay } from "../../functionsSimulator";
import "./matchCard.sass";

/**
 * Formatea una fecha ISO UTC al timezone del navegador.
 * Retorna { time: "22:00", date: "30 JUN" }
 */
function formatLocalDate(dateUTC) {
  if (!dateUTC) return { time: null, date: null };
  const d = new Date(dateUTC);
  if (isNaN(d.getTime())) return { time: null, date: null };

  const time = d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit", hour12: false });

  const day = d.getDate();
  const month = d.toLocaleString("es-MX", { month: "short" }).toUpperCase().replace(".", "");

  return { time, date: `${day} ${month}` };
}

export default function MatchCard({ match, onSelectWinner }) {
  const homeTeam = getTeamDisplay(match.home);
  const awayTeam = getTeamDisplay(match.away);
  const isPlaceholder = homeTeam.isPlaceholder || awayTeam.isPlaceholder;
  const isLocked = match.locked;
  const isDisabled = isPlaceholder || isLocked;

  const handleSelectWinner = (winner) => {
    if (isDisabled) return;
    onSelectWinner(match.id, winner);
  };

  const isHomeWinner = match.winner === match.home;
  const isAwayWinner = match.winner === match.away;
  const hasScore = match.homeScore !== null && match.awayScore !== null;

  const localDate = useMemo(() => formatLocalDate(match.dateUTC), [match.dateUTC]);

  return (
    <div className={`MatchCard ${isLocked ? "locked" : "selectable"}`}>
      <div className="MatchCardBody">
        <div className="MatchCardTeams">
          <button
            type="button"
            className={`MatchCardTeam ${homeTeam.isPlaceholder ? "placeholder" : ""} ${isHomeWinner ? "winner" : ""} ${isAwayWinner ? "loser" : ""}`}
            onClick={() => handleSelectWinner(match.home)}
            disabled={isDisabled}
          >
            {!homeTeam.isPlaceholder ? (
              <div className={`bandera-${homeTeam.flag}`}></div>
            ) : (
              <div className="bandera-placeholder"></div>
            )}
            <span className="TeamName">{homeTeam.display}</span>
          </button>

          <button
            type="button"
            className={`MatchCardTeam ${awayTeam.isPlaceholder ? "placeholder" : ""} ${isAwayWinner ? "winner" : ""} ${isHomeWinner ? "loser" : ""}`}
            onClick={() => handleSelectWinner(match.away)}
            disabled={isDisabled}
          >
            {!awayTeam.isPlaceholder ? (
              <div className={`bandera-${awayTeam.flag}`}></div>
            ) : (
              <div className="bandera-placeholder"></div>
            )}
            <span className="TeamName">{awayTeam.display}</span>
          </button>
        </div>

        <div className="MatchCardInfo">
          {hasScore ? (
            <div className="MatchCardScore">
              <span className={isHomeWinner ? "score-winner" : ""}>{match.homeScore}</span>
              <span className="score-dash">-</span>
              <span className={isAwayWinner ? "score-winner" : ""}>{match.awayScore}</span>
            </div>
          ) : (
            <>
              {localDate.time && <span className="MatchCardTime">{localDate.time}</span>}
              {localDate.date && <span className="MatchCardDate">{localDate.date}</span>}
            </>
          )}
        </div>
      </div>

      {match.venue && (
        <div className="MatchCardVenue">{match.venue}</div>
      )}
    </div>
  );
}
